import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { setSessionFailureHandler } from '../api/client';
import { clearSessionCache } from './session-cache';
import { publishSessionChange, subscribeSessionChanges } from './session-channel';
import { applySessionMessage, reconcileSessionHint } from './session-sync';

export { PRIVATE_QUERY_META } from './session-cache';

export const SessionBridge = () => {
  const client = useQueryClient();
  useEffect(
    () =>
      setSessionFailureHandler(() => {
        publishSessionChange({ type: 'signed-out' });
        void clearSessionCache(client);
      }),
    [client],
  );
  useEffect(
    () =>
      subscribeSessionChanges((message) => {
        void applySessionMessage(client, message);
      }),
    [client],
  );
  useEffect(() => {
    const reconcile = () => {
      if (document.visibilityState === 'hidden') return;
      void reconcileSessionHint(client);
    };
    window.addEventListener('focus', reconcile);
    document.addEventListener('visibilitychange', reconcile);
    return () => {
      window.removeEventListener('focus', reconcile);
      document.removeEventListener('visibilitychange', reconcile);
    };
  }, [client]);
  return null;
};
